import React, { useState } from "react";
import IconButton from "../../../share/buttons/IconButton";
import Card from "../../../share/cards/Card";
import { ReactComponent as Trash } from "../../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../../../Assets/Image/svg/addSession.svg";
import EmptyCourseDash from "../../../share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../../share/modal/Modal";
import TicketInfo from "../../Ticket/TicketInfo";
import { BsArrowLeft } from "react-icons/bs";
import { BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";
import { ReactComponent as TicketDot } from "../../../../Assets/Image/svg/ticketDot.svg";
import AdminPagination from "../../../share/Pageination/AdminPagination";
import AccessibilityInfo from "./AccessibilityInfo";
import Logo from "../../../../Assets/Image/png/adobe connect.png";
import MainPagination from "../../../share/Pageination/MainPagination";
import useFetch from "../../../../Hooks/useFetch";
import { useCreate } from "../../../../Context/CreateContext";

const CreateCourseAccessibility = (props) => {
    //Context
    const { phaseStatus, setPhaseStatus, bootCamp, setBootCamp } = useCreate();

    const [ticketInfo, setTicketInfo] = useState(false);
    const [upload, setUpload] = useState(false);
    const [emptyPage, setEmptyPage] = useState(false);
    const [bootcampRoles, setBootcampRoles] = useState();
    const [edit, setEdit] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const handleModal = () => {
        setUpload((perv) => !perv);
    };
    const handlePage = () => {
        setEmptyPage((perv) => !perv);
    };

    const getBootcampRoles = useFetch({
        method: "GET",
        url: `UserBootcampRollService/${bootCamp?.id}/bootcamp_rolls`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setBootcampRoles,
    });

    return (
        <div className=" mt-20">
            {bootcampRoles?.results?.length !== 0 ? (
                <>
                    <div className="flex justify-between items-center mb-20">
                        <h4 className="text-[2rem] text-purple-dark font-bold">
                            اطلاعات افراد بوت کمپ
                        </h4>
                        <BtnPrimary
                            text="+ ساخت دسترسی جدید"
                            className="px-16 py-7"
                            onClick={(e) => handleModal()}
                        />
                    </div>
                    <div className=" rounded-3xl overflow-hidden border-2 border-solid border-light-prim2">
                        <div className="accessibility-card accessibility-body bg-purple-dark-1 mb-4 font-bold text-black-prim">
                            <div>لوگو</div>
                            <div>نام</div>
                            <div>سمت</div>
                            <div>وبسایت</div>
                        </div>
                        {bootcampRoles?.results?.map((i) => (
                            <div
                                key={i.id}
                                className="accessibility-card accessibility-body  my-4 relative"
                            >
                                <div className=" text-black-prim">
                                    <img src={i.logo} />
                                </div>
                                <div>{i.name}</div>
                                <div className=" text-purple-dark cursor-pointer">
                                    {i.role}
                                </div>
                                <div className=" text-purple-dark">
                                    <a href={i.website} target="_blank">
                                        {i.website}
                                    </a>
                                </div>
                                <div className="">
                                    {!i.checked && (
                                        <div className="flex justify-around">
                                            <div className="flex flex-col justify-center items-center">
                                                <Trash />
                                                حذف
                                            </div>
                                            <div className="flex flex-col">
                                                <Edit />
                                                ویرایش
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={bootcampRoles?.results}
                        pageSize={bootcampRoles?.page_count}
                        className="mt-[3rem]"
                    />
                    <div className="flex  justify-between items-center mt-20">
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.prevStep}
                        >
                            <BsArrowRight />
                            <span>مرحله قبل</span>
                        </div>
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.nextStep}
                        >
                            <span>ثبت و ادامه</span>
                            <BsArrowLeft />
                        </div>
                    </div>
                    <Modal show={upload} closeModal={handleModal}>
                        <AccessibilityInfo
                            close={handleModal}
                            getBootcampRoles={getBootcampRoles}
                            edit={edit}
                            setEdit={setEdit}
                        />
                    </Modal>
                </>
            ) : (
                <EmptyCourseDash name="مدیر نقش" show={setEmptyPage} />
            )}
            <Modal show={emptyPage} closeModal={handlePage}>
                <AccessibilityInfo
                    close={handlePage}
                    getBootcampRoles={getBootcampRoles}
                    edit={edit}
                    setEdit={setEdit}
                />
            </Modal>
        </div>
    );
};

export default CreateCourseAccessibility;
